import { createFileRoute } from '@tanstack/react-router'

import { DetalheConfig } from '@/features/mergeguard/detalhe-config'
import {
  type BuscaDetalheConfig,
  buscaDetalheParaParametros,
  lerBuscaDetalhe,
} from '@/features/mergeguard/filtros'

export const Route = createFileRoute('/$perfil/mergeguard/$configHash')({
  validateSearch: (busca: Record<string, unknown>): BuscaDetalheConfig => lerBuscaDetalhe(busca),
  search: {
    // Hash só de dígitos vai como número, para o endereço não sair entre aspas.
    middlewares: [
      ({ search, next }) =>
        buscaDetalheParaParametros(next(search)) as unknown as BuscaDetalheConfig,
    ],
  },
  component: Tela,
})

function Tela() {
  // O hash do caminho é validado na página; da busca, só `comparar` validado chega.
  const { configHash } = Route.useParams()
  const busca = Route.useSearch({ select: lerBuscaDetalhe, structuralSharing: true })
  const navigate = Route.useNavigate()
  return (
    <DetalheConfig
      configHash={configHash}
      comparar={busca.comparar ?? null}
      aoComparar={(outro) =>
        void navigate({ search: lerBuscaDetalhe(outro ? { comparar: outro } : {}), replace: true })
      }
    />
  )
}
